export function isWizardBusy(state) {
  const {isFetching, isCurrentUserFetching} = state.currentUser
  const {isFetching: isMerchantFetching} = state.merchants
  const {isFetching: isSitesFetching} = state.sites
  const {isBusy: isBillingFetching} = state.billing

  return isFetching || isCurrentUserFetching || isSitesFetching || isMerchantFetching || isBillingFetching
}



// WEBPACK FOOTER //
// ./client/redux/modules/wizard/selectors.js